import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Sidebar.scss';

class Sidebar extends React.Component {
  static propTypes = {};

  render() {
    return (
      <div className={s.sidebar}>
        <span>gamify everything</span>
      </div>
    );
  }
}

export default withStyles(s)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js